export type AppTheme = 'porta' | 'portaNZ' | 'redRec';

const namespace = process.env.NEXT_PUBLIC_NAMESPACE;

export const theme: AppTheme =
  namespace === 'porta' || namespace === 'portaNZ' || namespace === 'redRec' ? namespace : 'porta';
